import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-env browser */
import React, { useMemo } from 'react';
import ItemsCarousel from '../ItemsCarousel/ItemsCarousel';
import styled from 'styled-components';
import useCarouselState from '../ItemsCarousel/hooks/useCarouselState';
import { CAROUSEL_CHEVRONS_WIDTH, CAROUSEL_OVERFLOW_SPACING } from '../constants';
import { ItemsCarouselWrapper } from '../ItemsCarousel';
import { useDeviceType } from '../../hooks/useDeviceType';
import { useMediaBreakpoints } from '../../hooks/useMediaBreakpoints';
import { getPx } from '../../helpers/common';
import { EMPTY_PROPS } from '../../helpers/types';
import { modifyProps } from '../../helpers/props';
import { styleArrayForBreakpoints } from '../../helpers/media-style';
import { combineByBreakpoints } from '../../helpers/media-combine';
var SHOW_CHEVRONS = {
  xs: false,
  sm: true
};
var SPRING_CONFIG = {
  xs: {
    tension: 160,
    friction: 20
  },
  sm: {}
};
var THRESHOLD = {
  xs: 0.125,
  sm: 0.25
};
var TRANSLATE_X_MULTIPLIER = 1.25;
var NUMBER_OF_CARDS = {
  xs: 1.25,
  sm: 3,
  lg: 4
};
var GUTTER = {
  xs: 16,
  sm: 20,
  lg: 24
};
var Wrapper = styled.div(_templateObject(), function (_ref) {
  var $fullWidth = _ref.$fullWidth,
      $showChevrons = _ref.$showChevrons;
  return styleArrayForBreakpoints([$showChevrons, CAROUSEL_CHEVRONS_WIDTH], function (_ref2) {
    var $showChevrons = _ref2[0],
        $width = _ref2[1];
    return $showChevrons && !$fullWidth && "\n          padding-left: " + getPx($width) + ";\n          padding-right: " + getPx($width) + ";\n        ";
  });
});
export var CardsCarouselWrapper = ItemsCarouselWrapper;

var CardsCarousel = function CardsCarousel(_ref3) {
  var id = _ref3.id,
      _ref3$withClickPreven = _ref3.withClickPrevention,
      withClickPrevention = _ref3$withClickPreven === void 0 ? true : _ref3$withClickPreven,
      _ref3$withNoEventsPro = _ref3.withNoEventsPropagation,
      withNoEventsPropagation = _ref3$withNoEventsPro === void 0 ? false : _ref3$withNoEventsPro,
      _ref3$useKeyboardCont = _ref3.useKeyboardControl,
      useKeyboardControl = _ref3$useKeyboardCont === void 0 ? false : _ref3$useKeyboardCont,
      slidesToScroll = _ref3.slidesToScroll,
      disableSwipeProp = _ref3.disableSwipe,
      _ref3$disableScrollOn = _ref3.disableScrollOnTouch,
      disableScrollOnTouch = _ref3$disableScrollOn === void 0 ? false : _ref3$disableScrollOn,
      _ref3$fullWidth = _ref3.fullWidth,
      fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$numberOfCards = _ref3.numberOfCards,
      numberOfCards = _ref3$numberOfCards === void 0 ? NUMBER_OF_CARDS : _ref3$numberOfCards,
      _ref3$defaultItemInde = _ref3.defaultItemIndex,
      defaultItemIndex = _ref3$defaultItemInde === void 0 ? 0 : _ref3$defaultItemInde,
      itemIndex = _ref3.itemIndex,
      onItemIndexChange = _ref3.onItemIndexChange,
      onStateChange = _ref3.onStateChange,
      _ref3$springConfig = _ref3.springConfig,
      springConfigProp = _ref3$springConfig === void 0 ? SPRING_CONFIG : _ref3$springConfig,
      _ref3$carouselProps = _ref3.carouselProps,
      carouselProps = _ref3$carouselProps === void 0 ? EMPTY_PROPS : _ref3$carouselProps,
      _ref3$alignX = _ref3.alignX,
      alignX = _ref3$alignX === void 0 ? 'flex-start' : _ref3$alignX,
      _ref3$chevronButtonSi = _ref3.chevronButtonSizeVariant,
      chevronButtonSizeVariant = _ref3$chevronButtonSi === void 0 ? 'medium' : _ref3$chevronButtonSi,
      _ref3$showChevrons = _ref3.showChevrons,
      showChevronsProp = _ref3$showChevrons === void 0 ? SHOW_CHEVRONS : _ref3$showChevrons,
      _ref3$chevronWidth = _ref3.chevronWidth,
      chevronWidthProp = _ref3$chevronWidth === void 0 ? CAROUSEL_CHEVRONS_WIDTH : _ref3$chevronWidth,
      _ref3$gutter = _ref3.gutter,
      gutter = _ref3$gutter === void 0 ? GUTTER : _ref3$gutter,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["id", "withClickPrevention", "withNoEventsPropagation", "useKeyboardControl", "slidesToScroll", "disableSwipe", "disableScrollOnTouch", "fullWidth", "disabled", "numberOfCards", "defaultItemIndex", "itemIndex", "onItemIndexChange", "onStateChange", "springConfig", "carouselProps", "alignX", "chevronButtonSizeVariant", "showChevrons", "chevronWidth", "gutter", "children"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var showChevrons = useMediaBreakpoints(showChevronsProp);
  var disableSwipeDefault = useMemo(function () {
    return modifyProps(showChevronsProp, function (showChevrons) {
      return showChevrons && !hasTouchScreen;
    });
  }, [showChevronsProp, hasTouchScreen]);
  var disableSwipe = useMediaBreakpoints(disableSwipeProp != null ? disableSwipeProp : disableSwipeDefault);
  var threshold = useMediaBreakpoints(THRESHOLD);
  var springConfig = useMediaBreakpoints(springConfigProp);

  var _useCarouselState = useCarouselState({
    children: children,
    numberOfCards: numberOfCards,
    itemIndex: itemIndex,
    defaultItemIndex: defaultItemIndex,
    onItemIndexChange: onItemIndexChange,
    onStateChange: onStateChange,
    useKeyboardControl: useKeyboardControl,
    disabled: disabled,
    slidesToScroll: slidesToScroll
  }),
      index = _useCarouselState.index,
      setActiveIndex = _useCarouselState.setActiveIndex;

  var chevronWidth = useMemo(function () {
    return combineByBreakpoints([chevronWidthProp, showChevronsProp], function (_ref4) {
      var width = _ref4[0],
          showChevrons = _ref4[1];
      return showChevrons ? width : 0;
    });
  }, [showChevronsProp, chevronWidthProp]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $showChevrons: showChevronsProp,
    $fullWidth: fullWidth
  }, props), /*#__PURE__*/React.createElement(ItemsCarousel, _extends({
    id: id,
    disabled: disabled,
    chevronButtonSizeVariant: chevronButtonSizeVariant,
    threshold: threshold,
    disableSwipe: disableSwipe,
    disableScrollOnTouch: disableScrollOnTouch,
    onActiveItemIndexChange: setActiveIndex,
    activeItemIndex: index,
    numberOfCards: numberOfCards,
    gutter: gutter,
    overflowSpacingVertical: CAROUSEL_OVERFLOW_SPACING,
    overflowSpacingHorizontal: showChevrons ? CAROUSEL_OVERFLOW_SPACING : 0,
    showChevrons: showChevronsProp,
    chevronWidth: chevronWidth,
    withOutsideChevrons: !fullWidth,
    springConfig: springConfig,
    fullWidth: fullWidth,
    slidesToScroll: slidesToScroll,
    translateXMultiplier: TRANSLATE_X_MULTIPLIER,
    withOverflowHidden: showChevronsProp,
    withUserSelectNone: !disableSwipe,
    withNoEventsPropagation: withNoEventsPropagation,
    withClickPrevention: withClickPrevention,
    alignX: alignX
  }, carouselProps), children));
};

export default CardsCarousel;